import { useState } from "react";
import { toast } from "sonner";
import { Play, Mail } from "lucide-react";
import { useApi, errMsg, inr } from "../lib/api";
import { useMember } from "../lib/member";
import { Button } from "./ui/button";

export const PayrollRun = ({ vendorId, month, onSaved }) => {
  const api = useApi();
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const { me } = useMember();
  const [mailing, setMailing] = useState(false);
  const mail = async () => {
    setMailing(true);
    try { const r = (await api.post("/payroll/email-slips", { vendor_id: vendorId, month })).data; toast.success(`Slip link for ${r.workers} workers emailed to ${r.sent} of ${r.recipients} recipient(s)`); }
    catch (e) { toast.error(errMsg(e)); }
    setMailing(false);
  };
  const run = async () => {
    setBusy(true);
    try { const r = (await api.post("/payroll/run", { vendor_id: vendorId, month })).data; setRes(r); toast.success(`Payroll created for ${r.processed} workers`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="grid gap-4">
      <p className="text-sm text-slate-400">Days = Present + ½ × Half days for the month. Rate = the worker's daily wage, or the Wage Master minimum for their category and zone. Workers with attendance get their row for the month recalculated; workers with no attendance are skipped and keep any existing row.</p>
      <div className="flex flex-wrap gap-2">
        <Button onClick={run} disabled={busy} data-testid="run-payroll-btn" className="w-fit bg-[#00E599] text-[#0B1017] hover:bg-[#00C482] font-semibold"><Play size={14} className="mr-2" />{busy ? "Running…" : "Run payroll from attendance"}</Button>
        {me?.role !== "vendor" && <Button variant="outline" onClick={mail} disabled={mailing} data-testid="email-slips-btn" className="border-[#1F2A3E] hover:bg-[#1A2234] hover:text-white"><Mail size={14} className="mr-2" />{mailing ? "Sending…" : "Email salary slips to contractor & HR"}</Button>}
      </div>
      {res && (
        <div className="rounded-lg border border-[#1F2A3E] bg-[#0B1017] p-4 font-mono text-sm" data-testid="payroll-result">
          {res.processed} processed · {res.skipped_no_attendance} skipped (no attendance) · {res.breaches} breach(es)
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
            {[["Gross", res.totals.gross], ["Employee PF", res.totals.pf], ["ESIC", res.totals.esic], ["Net pay", res.totals.net]].map(([k, v]) => (
              <div key={k}><div className="text-[10px] uppercase tracking-widest text-slate-500">{k}</div>{inr(v)}</div>))}
          </div>
        </div>)}
    </div>
  );
};
